import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { useDesignContext } from '@klarna/designtokens';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import View from '@bubble-ui/primitive-view';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import { defaultDesignTokens } from '../defaultDesignTokens';
import { DatePickerMain } from '../Main';
import { getNextMonthByDate, getPreviousMonthByDate } from './utils';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var DoubleMonth = _ref => {
  var {
    currentYear,
    disableDatesHandler,
    dueDate,
    firstDayOfWeek,
    id,
    isTodayShown,
    monthCurrentlyShown,
    monthNames,
    nextMonthLabel,
    onChange,
    onGoToNextMonth,
    onGoToPreviousMonth,
    previousMonthLabel,
    rangeSelection,
    value,
    weekDayOneLetterNames
  } = _ref;
  var designVersion = useDesignVersion();
  var designContext = useDesignContext(defaultDesignTokens);
  var {
    rootStyle,
    divider
  } = getDefaultStyleSheet({
    designVersion,
    designContext
  });
  var ids = getIds(id);
  var onGoToNextMonthRightMonth = onGoToNextMonth && (value => onGoToNextMonth(getPreviousMonthByDate(value)));
  var doubleMonthProps = {
    currentYear,
    disableDatesHandler,
    doubleMonth: true,
    dueDate,
    firstDayOfWeek,
    isTodayShown,
    monthCurrentlyShown,
    monthNames,
    nextMonthLabel,
    onChange,
    onGoToPreviousMonth,
    previousMonthLabel,
    rangeSelection,
    value,
    weekDayOneLetterNames
  };
  var leftProps = _objectSpread(_objectSpread({}, doubleMonthProps), {}, {
    onGoToNextMonth: undefined,
    id: ids === null || ids === void 0 ? void 0 : ids.left
  });
  var rightProps = _objectSpread(_objectSpread({}, doubleMonthProps), {}, {
    onGoToPreviousMonth: undefined,
    monthCurrentlyShown: getNextMonthByDate(monthCurrentlyShown),
    onGoToNextMonth: onGoToNextMonthRightMonth,
    id: ids === null || ids === void 0 ? void 0 : ids.right
  });
  return /*#__PURE__*/React.createElement(View, {
    style: rootStyle,
    id: ids === null || ids === void 0 ? void 0 : ids.root
  }, /*#__PURE__*/React.createElement(DatePickerMain, leftProps), /*#__PURE__*/React.createElement(View, {
    style: divider
  }), /*#__PURE__*/React.createElement(DatePickerMain, rightProps));
};
DoubleMonth.displayName = 'DoubleMonth';
export var DatePickerDoubleMonth = withProvisionalOverrideFromContext(DoubleMonth);
//# sourceMappingURL=index.js.map